import request from '../../axios';

const getHomepageStoreNotifModal = async () => {
  const {data}: {data: IStoreModal} = await request.get(
    `api/v2/store/store-modal`,
  );
  return data;
};

export default getHomepageStoreNotifModal;
